import {
  Component,
  Input,
  Output,
  HostListener,
  HostBinding,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'bui-row-expand-icon',
  template: ``
})
export class RowExpandIconComponent {
  @Input() isExpand = false;
  @Input() @HostBinding('class.ant-table-row-spaced') isShowExpand = false;
  @Output() isExpandChange = new EventEmitter();

  @HostBinding(`class.ant-table-row-expanded`)
  get expanded() {
    return this.isExpand && !this.isShowExpand;
  }

  @HostBinding(`class.ant-table-row-collapsed`)
  get collapsed() {
    return !this.isExpand && !this.isShowExpand;
  }

  @HostBinding(`class.ant-table-row-expand-icon`) _expandIcon = true;


  @HostListener('click')
  onClick() {
    this.isExpand = !this.isExpand;
    this.isExpandChange.emit(this.isExpand);
  }

  constructor() {
  }
}
